import { unfactorServerTimeZone } from './tz.js'
import tmpl_fnma from './components/fnma.pug'
import tmpl_finTable from './components/finTable.pug'
import { store } from './models/store.js'
import OhlcComponent from './components/ohlc.js'
import LinechartComponent from './components/linechart.js'
import FnmaComponent from './components/fnma.js'
import TableComponent from './components/table.js'
import EconcalComponent from './components/econcal.js'
import Modal from './components/modal.js'

export interface DashboardParams {
    fj: string;
    freeversion: boolean;
    embedversion: boolean;
    sendmodal: boolean;
    startCpn: string;
}

export function initDashboard(params: DashboardParams): void {
    $.template.init();

    let modal = new Modal();
    let lineChart = new LinechartComponent({el: '#line-chart'}, {parse: true});
    let candleChart = new OhlcComponent({el: '#candlestick-chart'}, {parse: true});
    let fnmaTable = new FnmaComponent({id: 'fnma', el: '#fnma_table'}, {parse: true});
    let gnmaTable = new TableComponent({id: 'gnma', el: '#gnma_table'}, {parse: true});
    let armsTable = new TableComponent({id: 'arms', el: '#arms_table'}, {parse: true});
    let indicesTable = new TableComponent({id: 'indices', el: '#indices_table'}, {parse: true});
    let econcalTable = new EconcalComponent({id: 'econcal', el: '#econcal'}, {parse: true})
    
    // ---- Charts globals ----
    function setGraphTitle(txt: string): void { store.caption = txt; }

    function processExtras(extras: any): void {
        if (!extras) return;
        if (extras.nasdaq) {
            const n = extras.nasdaq;
            $('#nasdaq').html('<strong style="color:' + n.color + ';">' + n.cfo + '</strong> NASDAQ<br>' + n.last + ' ');
        }
        if (extras.tenyr) {
            const t = extras.tenyr;
            $('#tenyr').html('<strong style="color:' + t.color + ';">' + t.val + '</strong> 10Y Treasury <br> Yield: ' + t.yield + ' ');
        }
        if (extras.gnmaDayChange) {
            const g = extras.gnmaDayChange;
            $('#gnmaDayChange').html('<strong style="color:' + g.color + ';">' + g.val + '</strong>BPS GNMA<br> Day Change');
        }
        if (extras.fnmaDayChange) {
            const f = extras.fnmaDayChange;
            if (f.bubble !== undefined && (window as any).Tinycon) (window as any).Tinycon.setBubble(f.bubble);
            $('#fnmaDayChange').html('<strong style="color:' + f.color + ';">' + f.val + '</strong> BPS FNMA<br> Day Change');
            if (f.title) document.title = f.title;
        }
    }

    function showChart(idx) {
        store.choice = idx;        
    }
    $("#ohlc_btn").click(() => showChart(0))
    $("#line_btn").click(() => showChart(1))
    
    candleChart.on("extras", extras => processExtras(extras));
    lineChart.on("extras", extras => processExtras(extras));
    
    function updateInfoTitle() {
        let caption = ''
        if (store.currdt) {
            const epochTicks = 621355968000000000n;
            let ticks = BigInt(store.currdt);
            let serverMSecs = Number((ticks - epochTicks) / 10000n);
            let n = unfactorServerTimeZone(serverMSecs);
            caption = dateFormat(new Date(n), 'dddd, mmmm dS, yyyy, h:MM:ss TT')
        }
        if (store.caption) {
            caption = store.caption + ' ' + caption;
        }
        $('#ldt').html(caption)        
    }
    
    function changeCap(cap) {
        store.caption = cap;
        updateInfoTitle();
    }
    
    lineChart.on("caption", changeCap);
    candleChart.on("caption", changeCap);
    
    store.on("change:currdt", () => {
        if (!store.currdt) return;
        updateInfoTitle();
    });
    store.set(params, {parse: true});
    store.checkDt();
}
